
import React, { useRef, useEffect } from 'react';
import { Checkbox } from "@/components/ui/checkbox";

interface IndeterminateCheckboxProps {
  id: string;
  checked?: boolean;
  indeterminate?: boolean;
  onCheckedChange?: () => void;
}

export function IndeterminateCheckbox({ 
  id, 
  checked, 
  indeterminate, 
  onCheckedChange 
}: IndeterminateCheckboxProps) {
  const checkboxRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (checkboxRef.current) {
      // Apply indeterminate property to the DOM element
      if (typeof indeterminate === 'boolean') {
        checkboxRef.current.dataset.state = indeterminate ? 'indeterminate' : checked ? 'checked' : 'unchecked';
        
        // Some visual indication of indeterminate state with CSS in React
        if (indeterminate) {
          checkboxRef.current.style.background = 'linear-gradient(to right, hsl(var(--primary)) 50%, transparent 50%)';
        } else {
          checkboxRef.current.style.background = '';
        }
      }
    }
  }, [indeterminate, checked]);

  return (
    <Checkbox
      ref={checkboxRef}
      id={id}
      checked={checked}
      onCheckedChange={onCheckedChange}
    />
  );
}
